$(document).ready(function(){
  // Rooms and Things To Do
  if($('.slider').length) {
    $('.slider').slick({
      lazyLoad:'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      infinite: false
    });
  }

  // Home and Reviews
  if($('.reviews').length) {
    $('.reviews').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      adaptiveHeight: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });


    $('.review').find('.expander').each(function(){
      let description = $(this).parent().find('.description');
      // if description doesn't need expander, remove it.
      if(description.prop('scrollHeight') <= description.height()+1) {
        description.css('height', 'auto');
        $(this).remove();
      }
      $(this).click(function(e) {
        e.preventDefault();
        const button = $(this);
        const description = button.parent().find('.description');

        if (description.hasClass('open')) {
          description.animate({height: '12em'}, 300, function() {
            description.removeClass('open');
            button.html('...expand to keep reading');
          });
        } else {
          const reducedHeight = description.height();
          description.css('height', 'auto');
          const fullHeight = description.height();
          description.height(reducedHeight);

          description.animate({height: fullHeight}, 300, function() {
            description.addClass('open');
            button.html('show less');
          });
        }
      });
    });
  }
});


// WEBPACK FOOTER //
// ./public/javascripts/modules/sliders.js